import { Injectable, signal } from "@angular/core";

type Theme = 'light' | 'dark';

const CURRENT_THEME = 'app-theme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    theme = signal<Theme>(this.getInitial());

    readonly currentTheme = this.theme.asReadonly();

    private getInitial(): Theme {
        const persisted = localStorage.getItem(CURRENT_THEME) as Theme | null;
        if (persisted) return persisted;

        // Fallback to system preference
        return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    apply(theme: Theme) {
        this.theme.set(theme);
        localStorage.setItem(CURRENT_THEME, theme);
        document.documentElement.setAttribute('data-theme', theme);
    }

    toggle() {
        this.apply(this.theme() === 'dark' ? 'light' : 'dark');
    }
}